import type React from 'react';

import { DesignSystemLegacy } from '@change-corgi/design-system-legacy/core';
import { Box } from '@change-corgi/design-system-legacy/layout';
import { sunriseTheme } from '@change-corgi/design-system-legacy/theme';

import { usePetitionDetailsPageUserData } from 'src/app/pages/petitionDetails/pageContext';

import { MediaHitsContextProvider } from '../containers/MediaHitsContainerSunrise';
import { PetitionStatsContextProvider } from '../hooks/petitionStats';
import { ScrollContextProvider } from '../hooks/useScrollToSection';

import { DetailsStateWrapper } from './DetailsStateWrapper';

type Props = Readonly<{
	slug: string;
}>;

export const DetailsWithContext: React.FC<Props> = ({ slug }) => {
	const {
		data: { isSunriseEnabled },
	} = usePetitionDetailsPageUserData();

	return (
		<PetitionStatsContextProvider slug={slug}>
			<MediaHitsContextProvider>
				<ScrollContextProvider>
					<DesignSystemLegacy theme={isSunriseEnabled ? sunriseTheme : undefined}>
						{/*
						 * This is a hack around the fact that design-system-legacy Text doesn't use color tokens by
						 * default; it leaves color property unset, which means it is inherited. This means that
						 * overriding out tokens ('typography-primary') with the theme doesn't affect most text. But,
						 * because the color is just inherited, we can set it here and it will cascade to all text that
						 * doesn't have a more specific property.
						 */}
						<Box sx={isSunriseEnabled ? { color: 'sunrise.semantic.typography.strong' } : undefined}>
							<DetailsStateWrapper />
						</Box>
					</DesignSystemLegacy>
				</ScrollContextProvider>
			</MediaHitsContextProvider>
		</PetitionStatsContextProvider>
	);
};
